
import React, { useEffect, useState } from 'react';
import { getYoutubeVideos } from '../services/wordpress';
import { Video } from '../types';
import { PlayCircle, ArrowUpRight, AlertTriangle } from 'lucide-react';
import './VideoSection.css';

const VideoSection: React.FC = () => {
  const [videos, setVideos] = useState<Video[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadVideos() {
      const data = await getYoutubeVideos();
      setVideos(data);
      setLoading(false);
    }
    loadVideos();
  }, []);

  return (
    <section className="VideoSection_section">
      <div className="container">
        <div className="VideoSection_header">
          <h2 className="VideoSection_title">Multimedia</h2>
          <p className="VideoSection_subtitle">
            Simak diskusi mendalam, webinar, dan dokumentasi lapangan terbaru dari kanal Lakpesdam PBNU.
          </p>
        </div>

        {loading ? (
           <div className="VideoSection_grid" role="status">
             {[1, 2, 3].map((i) => (
               <div key={i} className="VideoSection_card" style={{ border: '1px solid #e2e8f0', overflow: 'hidden' }}>
                 <div style={{ width: '100%', height: '200px', backgroundColor: '#e2e8f0', animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' }} />
                 <div className="VideoSection_content" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', padding: '1rem' }}>
                   <div style={{ width: '90%', height: '24px', backgroundColor: '#e2e8f0', borderRadius: '4px', animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' }} />
                   <div style={{ width: '60%', height: '24px', backgroundColor: '#e2e8f0', borderRadius: '4px', animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' }} />
                   <div style={{ width: '30%', height: '16px', backgroundColor: '#e2e8f0', borderRadius: '4px', animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite', marginTop: '0.5rem' }} />
                 </div>
               </div>
             ))}
             <span className="sr-only">Memuat video...</span>
             <style>{`@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: .5; } }`}</style>
           </div>
        ) : (
          <div className="VideoSection_grid">
            {videos.map((video) => (
              <a 
                key={video.id} 
                href={video.url}
                target="_blank"
                rel="noopener noreferrer"
                className="VideoSection_card block"
                aria-label={`${video.title} (terbuka di YouTube, tab baru)`}
              >
                <div className="VideoSection_thumbnailWrapper">
                  <img 
                      src={video.thumbnailUrl} 
                      alt={video.title} 
                      className="VideoSection_thumbnail"
                      loading="lazy"
                      width="600"
                      height="340"
                  />
                  <div className="VideoSection_playOverlay">
                      <PlayCircle size={48} className="VideoSection_playIcon" />
                  </div>
                  {/* Tampilkan durasi jika ada (dari dummy), jika dari RSS tampilkan tanggal */}
                  <div className="VideoSection_duration">
                      {video.duration || video.date}
                  </div>
                </div>
                <div className="VideoSection_content">
                  <h3 className="VideoSection_cardTitle">
                      {video.title}
                  </h3>
                  <span className="VideoSection_tag">Video Terbaru</span>
                  {video.isFallback && (
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', backgroundColor: 'rgba(255, 255, 255, 0.9)', color: '#d97706', padding: '0.25rem 0.5rem', borderRadius: '0.5rem', fontSize: '0.75rem', fontWeight: 700, marginLeft: '0.5rem', border: '1px solid #d97706' }}>
                      <AlertTriangle size={14} /> Mode Offline
                    </div>
                  )}
                </div>
              </a>
            ))}
          </div>
        )}
        
        <div className="VideoSection_footer">
            <a 
                href="https://www.youtube.com/channel/UCAXV9NWByHzVO4e6g5fUcyQ" 
                target="_blank" 
                rel="noopener noreferrer"
                className="VideoSection_btnAll inline-flex items-center gap-2"
                style={{ textDecoration: 'none' }}
            >
                Lihat Kanal YouTube <ArrowUpRight size={16} />
            </a>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
